import React from 'react';
import styles from '../../pages/DiagramPage/DiagramEditor.module.css';
import { TextElement } from '../../types/diagram.types';

interface TextComponentProps {
  text: TextElement;
  isSelected: boolean;
  isEditMode: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
  onDoubleClick: () => void;
}

export const TextComponent: React.FC<TextComponentProps> = ({
  text,
  isSelected,
  isEditMode,
  onMouseDown,
  onDoubleClick,
}) => (
  <div
    className={`${styles.textElement} ${isSelected ? styles.textElementSelected : ''} ${!isEditMode ? styles.textElementViewMode : ''}`}
    style={{
      left: text.position.x,
      top: text.position.y,
      fontSize: text.fontSize,
      color: text.color,
      cursor: isEditMode ? 'move' : 'default',
    }}
    onMouseDown={onMouseDown}
    onDoubleClick={onDoubleClick}
  >
    {text.text}
  </div>
);